module.exports = __webpack_public_path__ + "assets/filter-kosher-520055.svg";